module.exports = __webpack_public_path__ + "static/media/banner-basket-mobile.f7c2d758.png";